import React,{useState} from 'react';
import { authApi } from '../services/apiClient';
import { Database, LockKeyhole, Mail, UserRound, Building2 } from 'lucide-react';
import metricusLogo from '@process-advisor/assets/metricusLogoSmall.png';

function MicrosoftIcon(){
  return <svg aria-hidden="true" viewBox="0 0 23 23" className="provider-svg">
    <path fill="#f25022" d="M1 1h10v10H1z"/>
    <path fill="#7fba00" d="M12 1h10v10H12z"/>
    <path fill="#00a4ef" d="M1 12h10v10H1z"/>
    <path fill="#ffb900" d="M12 12h10v10H12z"/>
  </svg>;
}
function GoogleIcon(){
  return <svg aria-hidden="true" viewBox="0 0 24 24" className="provider-svg">
    <path fill="#4285F4" d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z"/>
    <path fill="#34A853" d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z"/>
    <path fill="#FBBC05" d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l3.66-2.84z"/>
    <path fill="#EA4335" d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z"/>
  </svg>;
}

export default function AuthPage({mode='login',onMode,onAuthenticated,health}){
  const [form,setForm]=useState({displayName:'',workspaceName:'My Workspace',email:'',password:''});
  const [busy,setBusy]=useState(false),[error,setError]=useState('');
  const set=k=>e=>setForm(v=>({...v,[k]:e.target.value}));
  const submit=async e=>{
    e.preventDefault();setBusy(true);setError('');
    try{
      const {authApi}=await import('../services/apiClient');
      const result=mode==='signup'
        ? await authApi.signup(form)
        : await authApi.login(form.email,form.password);
      onAuthenticated(result.identity);
    }catch(err){setError(err.message||'Unable to continue');}
    finally{setBusy(false);}
  };
  return <div className="auth-root">
    <div className="auth-brand-panel">
      <div className="auth-brand"><img src={metricusLogo}/><div><b>Process Advisor</b><span>Process intelligence &amp; advisory</span></div></div>
      <div className="auth-value">
        <div className="eyebrow">PROCESS INTELLIGENCE &amp; ADVISORY</div>
        <h1>AI-assisted enterprise process advisory, grounded in process mining evidence.</h1>
        <p>Process Advisor combines process mining, deterministic analysis and AI-assisted consulting in one workspace, turning operational evidence into practical recommendations and improvement roadmaps.</p>
        <div className="auth-value-points">
          <div><Database size={19}/><span>DB-backed process models and assessment history</span></div>
          <div><LockKeyhole size={19}/><span>Secure workspace isolation</span></div>
        </div>
      </div>
    </div>
    <div className="auth-form-panel">
      <div className="auth-card">
        <div className="auth-card-head"><h2>{mode==='signup'?'Create your account':'Welcome back'}</h2><p>{mode==='signup'?'Create your workspace and first account.':'Sign in to your Process Advisor workspace.'}</p></div>
        {error&&<div className="auth-error">{error}</div>}
        <div className="auth-social auth-social-primary">
          <a className={!health?.auth?.microsoft?'disabled':''} href={health?.auth?.microsoft?authApi.oauthUrl('microsoft'):undefined} onClick={e=>{if(!health?.auth?.microsoft)e.preventDefault();}}>
            <MicrosoftIcon/>
            <span className="provider-label">Continue with Microsoft</span>
          </a>
          <a className={!health?.auth?.google?'disabled':''} href={health?.auth?.google?authApi.oauthUrl('google'):undefined} onClick={e=>{if(!health?.auth?.google)e.preventDefault();}}>
            <GoogleIcon/>
            <span className="provider-label">Continue with Google</span>
          </a>
        </div>
        <div className="auth-divider"><span>or use email</span></div>
        <form onSubmit={submit} className="auth-form">
          {mode==='signup'&&<>
            <label><span>Your name</span><div className="auth-input"><UserRound size={17}/><input value={form.displayName} onChange={set('displayName')} autoComplete="name" required/></div></label>
            <label><span>Workspace name</span><div className="auth-input"><Building2 size={17}/><input value={form.workspaceName} onChange={set('workspaceName')} placeholder="My Workspace" required/></div></label>
          </>}
          <label><span>Email</span><div className="auth-input"><Mail size={17}/><input type="email" value={form.email} onChange={set('email')} autoComplete="email" required/></div></label>
          <label><span>Password</span><div className="auth-input"><LockKeyhole size={17}/><input type="password" value={form.password} onChange={set('password')} autoComplete={mode==='signup'?'new-password':'current-password'} minLength={mode==='signup'?10:1} required/></div>{mode==='signup'&&<small>At least 10 characters.</small>}</label>
          <button className="auth-primary" disabled={busy}>{busy?'Please wait…':mode==='signup'?'Create account':'Sign in'}</button>
        </form>
        <div className="auth-switch">{mode==='signup'?'Already have an account?':'New to Process Advisor?'} <button onClick={()=>onMode(mode==='signup'?'login':'signup')}>{mode==='signup'?'Sign in':'Create account'}</button></div>
      </div>
    </div>
  </div>;
}
